import { render } from "./AddItemModal.vue?vue&type=template&id=12e9e66e&scoped=true"
import script from "./AddItemModal.vue?vue&type=script&lang=js"
export * from "./AddItemModal.vue?vue&type=script&lang=js"

import "./AddItemModal.vue?vue&type=style&index=0&id=12e9e66e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e9e66e"]])

export default __exports__